import { useState, useEffect } from 'react';
//import { createGame, endActiveGame } from './Queries';
import blue_timer_robot from '../resources/extras/glitch_blue_scoreboard.png';


const Timer = () => {
    const [isActive, setIsActive] = useState(false);
    const [seconds, setSeconds] = useState(0);
    const [minutes, setMinutes] = useState(0);      
    
    useEffect(() => {
      let timer: any = null;
      if(seconds > 59)
      {
          setMinutes(minutes + 1);
          setSeconds(seconds - 60);
      }
      if(isActive){
        timer = setInterval(() => {
          setSeconds((prevSeconds) => {
            if (prevSeconds <= 0) {
              if (minutes <= 0) {
                setIsActive(false);
                return 0;
              } else {
                setMinutes((prevMinutes) => prevMinutes - 1);
                return 59;
              }
            }
            return prevSeconds - 1;
          });
        }, 1000);
        if(seconds <= 0) {
            setIsActive(false);
            //endActiveGame();
        }
      }
      return () => {
        clearInterval(timer);
      };
    }, [isActive, seconds, minutes]);
    return (
          <div className="timer-all-elements-container">
            <div className="timer-btns-container">
              <button onClick={() => {
                if (minutes <= 0 && seconds <= 10){
                  setSeconds(0);
                }else if (seconds <= 10 && minutes >= 0){
                    setMinutes(Math.max(minutes - 1, 0));
                    setSeconds(seconds + 50)
                }else{
                  setSeconds(seconds - 10); 
                }
                }} className="minus_time_button"></button>
                <button onClick={() => setSeconds(seconds + 10)} className="add_time_button"></button>
              </div>
              <div className="timer-container">
                <div className="timer-all-elements-container">
                  <p className="timer-text">Time:</p>
                  <p className="timer-text">{String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}</p>
                </div>
              </div>
              <img src={blue_timer_robot} alt="Blue Timer Robot" className="blue_timer_robot" />
          
                <button className='start-lazer' onClick={()=>{
                  setIsActive(true);
                  //createGame();
                }}> Start Game </button>
        </div>
    );
  };

  export default Timer;